import { log } from "./helper";

export class StorefrontCinema {
	init() {
		log.info("Initialize StorefrontCinema");
	}
}
